import { Button, Card, Flex, List, message, Select, Spin, Tabs, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import usePermissions from '../../hooks/usePermissions';
import { FilterOutlined } from '@ant-design/icons';
import { CSSTransition } from "react-transition-group";
import SearchFilters from '../../page-components/HelpCenters/SearchFilters';
import HelpCenterTicketModal from '../../page-components/HelpCenters/HelpCenterTicketModal';
import TicketListTable from '../../page-components/HelpCenters/TicketListTable';
import { useMediaQuery } from 'react-responsive';
import UpdateListTable from '../../components/UpdateListTable';
import UpdateModalForm from '../../components/UpdateModalForm';
import axiosInstance from '../../services/axiosInstance';
import { catchError } from '../../utils/errorHandler';
import { useDispatch } from 'react-redux';
import { toggleSidebarCollapsed } from '../../redux/slices/uiSlice';
import HelpDocView from '../../page-components/HelpCenters/HelpDocView';
import SearchRaiseFilters from '../../page-components/HelpCenters/SearchRaiseFilters';

const { Option } = Select;
const { Paragraph } = Typography;
const { TabPane } = Tabs;

const Helpcenter = () => {
    const [loading, setLoading] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [activeTab, setActiveTab] = useState("new-update");
    const { hasPermission } = usePermissions();
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
    const dispatch = useDispatch()
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: false,
    });





    // New Updates
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [groupPermission, setGroupPermission] = useState([]);
    const [emailPermission, setEmailPermission] = useState([]);
    const [dashboardUpdates, setDashboardUpdates] = useState([]);
    const [formLoading, setFormLoading] = useState(false)
    const [singleLoading, setSingleLoading] = useState(false)

    const fetchGroupPermissions = async () => {
        setLoading(true);
        try {
            const [res, res2] = await Promise.all([
                axiosInstance.get('/notifications/v2/group-permissions/dropdown/'),
                axiosInstance.get('/useraccount/v2/internal-active-users/')
            ]);

            if (res.data.status === 'success') {
                setGroupPermission(res.data.data);
            }

            if (res2.data.status === 'success') {
                setEmailPermission(res2.data.data);
            }

        } catch (err) {
            console.error('Group Permission Fetch Error:', err);
        } finally {
            setLoading(false);
        }
    };

    const fetchDashboardUpdates = async () => {
        setLoading(true);
        try {
            const res = await axiosInstance.get('/notifications/v2/updates/create/');

            if (res.status === 200) {
                setDashboardUpdates(res.data.results?.data);
                setPagination({
                    ...pagination,
                    total: res.data.count || 0,
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                });
                setLoading(false)
            }
        } catch (err) {
            console.log('Dashboard Updates Fetch Error:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleModalSubmit = async (formData) => {
        setFormLoading(true)
        try {
            const res = await axiosInstance.post('/notifications/v2/updates/create/', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (res.status === 201 && res.data.status === "success") {
                message.success(res.data.data)
                fetchDashboardUpdates();
                setIsModalOpen(false);
                setFormLoading(false)
            }
            return res;
        } catch (err) {
            setFormLoading(false)
            await catchError(err)
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false)
    }

    //   Help Docs
    const [helpDocsData, setHelpDocsData] = useState([]);
    const [selectedDoc, setSelectedDoc] = useState(""); // uid
    const [singledata, setSingledata] = useState({});
    const [helpLoading, setHelpLoading] = useState(false)

    const getHelpDocsAndSingleDoc = async () => {
        setHelpLoading(true);
        try {
            const listRes = await axiosInstance.get("/api/v2/helpcentre/docs/list/");
            if (listRes.status === 200 && listRes.data.status === 'success') {
                const list = listRes.data.data;
                setHelpDocsData(list);

                if (list.length > 0) {
                    const firstUid = list[0].uid;
                    setSelectedDoc(firstUid);

                    const singleRes = await axiosInstance.get(`/api/v2/help-doc/${firstUid}/`);
                    if (singleRes.status === 200 && singleRes.data.status === 'success') {
                        setSingledata(singleRes.data.data);
                    }
                }
            }
        } catch (err) {
            console.error('Error fetching help docs or single doc:', err);
        }
        setHelpLoading(false);
    };

    const fetchSingleDoc = async (uid) => {
        if (!uid) return;
        setSingleLoading(true);
        try {
            const res = await axiosInstance.get(`/api/v2/help-doc/${uid}/`);
            if (res.status === 200 && res.data.status === 'success') {
                setSingledata(res.data.data);
            }
        } catch (err) {
            console.error('Error fetching single doc:', err);
        }
        setSingleLoading(false);
    };

    const handleChange = (value) => {
        setSelectedOption(value);
    };

    const toggleFilters = () => {
        setShowFilters(!showFilters);
    };

    const openModal = () => {
        setIsModalVisible(true);
    };

    const closeModal = () => {
        setIsModalVisible(false);
    };

    // Raise Ticket    
    const [ticketListData, setTicketListData] = useState([]);
    const [selectedOption, setSelectedOption] = useState("my-ticket");
    const [filtersList, setFiltersList] = useState([])

    //filters
    const [filters, setFilters] = useState({});
    console.log("filters", filters)

    const handleSearchClick = (newFilters) => {
        setFilters(newFilters)
        setPagination({ ...pagination, current: 1 });
    }

    const handleResetClick = () => {
        setFilters({})
        setPagination({ ...pagination, current: 1 });
    }

    const fetchMyTicketListData = async () => {
        setLoading(true);
        const query = new URLSearchParams({
            page: pagination.current,
            page_size: pagination.pageSize
        }).toString();
        try {
            const res = await axiosInstance.get(`/useraccount/v2/my-ticket/?${query}`);
            if (res.status === 200) {
                setTicketListData(res.data.results.data);
                setPagination({
                    ...pagination,
                    total: res.data.count || 0,
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                });
            }
        } catch (err) {
            console.log('Ticket List Fetch Error:', err);
        } finally {
            setLoading(false);
        }
    };

    const fetchAllTicketListData = async (filters) => {

        setLoading(true);
        const query = new URLSearchParams({
            page: pagination.current,
            page_size: pagination.pageSize,
            ...filters
        }).toString();
        try {
            const res = await axiosInstance.get(`/useraccount/v2/all-ticket/?${query}`);
            if (res.status === 200) {
                setTicketListData(res.data.results.data);
                setFiltersList(res?.data?.results?.filters)
                setPagination({
                    ...pagination,
                    total: res.data.count || 0,
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                });
            }
        } catch (err) {
            console.log('Ticket List Fetch Error:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleTabChange = (key) => {
        setActiveTab(key);
        setPagination({
            current: 1,
            pageSize: 10,
            total: 0,
            showSizeChanger: false,
        });
    };


    const handleSelectDoc = (uid) => {
        setSelectedDoc(uid);
        fetchSingleDoc(uid);
    };

    useEffect(() => {
        setSelectedOption("my-ticket");
        if (activeTab === "raised-ticket" && selectedOption === "my-ticket") {
            setFilters({})
        }
        if (activeTab === "help-document") {
            dispatch(toggleSidebarCollapsed())
        }
    }, [activeTab])

    useEffect(() => {
        if (activeTab === "raised-ticket") {
            if (selectedOption === "my-ticket") {
                fetchMyTicketListData();
            } else if (selectedOption === "all-ticket" && hasPermission("can_view_all_tickets")) {
                fetchAllTicketListData(filters);
            }
        } else if (activeTab === "help-document") {
            getHelpDocsAndSingleDoc();
        } else if (activeTab === "new-update") {
            fetchGroupPermissions();
            fetchDashboardUpdates();
        }
    }, [activeTab, pagination.current, pagination.pageSize, selectedOption, filters])

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                padding: "20px",
            }}>
            {(showFilters && selectedOption === "all-ticket") && (
                <SearchRaiseFilters
                    filtersList={filtersList}
                    onSearch={handleSearchClick}
                    onCancel={handleResetClick}
                    loading={loading}
                />
            )}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexDirection: "row",
                    gap: 0,
                    width: "100%",
                    marginBottom: "15px"
                }}
            >
                {activeTab !== "help-document" && (
                    <Paragraph
                        style={{
                            fontWeight: 500,
                            opacity: 0.6,
                            textAlign: "left",
                            margin: 0,
                            padding: 0,
                        }}>
                        Showing{" "}
                        {Math.min(
                            (pagination.current - 1) * pagination.pageSize + 1,
                            pagination.total
                        )}{" "}
                        -
                        {Math.min(
                            pagination.current * pagination.pageSize,
                            pagination.total
                        )}{" "}
                        of {pagination.total}
                    </Paragraph>
                )}

                {activeTab === "new-update" && hasPermission("can_view_group_permission_column_in_new_update") && (
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            style={{ background: '#001529', color: 'white' }}
                            onClick={() => setIsModalOpen(true)}
                            disabled={loading}
                        >
                            Add New Update
                        </Button>
                    </div>
                )}

                {activeTab === "raised-ticket" && (
                    <Flex gap={4}>
                        <Select
                            placeholder="Select an action"
                            style={{ width: "100%" }}
                            value={selectedOption}
                            onChange={handleChange}
                        >
                            <Option value="my-ticket">My Ticket</Option>
                            {hasPermission("can_view_all_tickets") &&
                                <Option value="all-ticket">All Ticket</Option>}
                        </Select>

                        <Button
                            type="primary"
                            onClick={openModal}
                            style={{ background: "#001529", color: "white" }}
                        >
                            Add Ticket
                        </Button>
                        {selectedOption === "all-ticket" && (
                            <Button
                                type="primary"
                                style={{ background: "#001529", padding: "10px" }}
                                icon={<FilterOutlined />}
                                onClick={toggleFilters}
                            />
                        )}
                    </Flex>
                )}
            </div>

            <Tabs
                activeKey={activeTab}
                onChange={handleTabChange}
            >
                <TabPane tab="Release Updates" key="new-update">
                    <UpdateListTable
                        data={dashboardUpdates}
                        loading={loading}
                        fetchDashboardUpdates={fetchDashboardUpdates}
                    />
                    <UpdateModalForm
                        open={isModalOpen}
                        onCancel={handleCloseModal}
                        onSubmit={handleModalSubmit}
                        groupPermission={groupPermission}
                        emailPermission={emailPermission}
                        isMobile={isMobile}
                        formLoading={formLoading}
                    />
                </TabPane>

                <TabPane tab="Feature Guides" key="help-document">
                    <HelpDocView
                        loading={helpLoading}
                        data={helpDocsData}
                        selectedDoc={selectedDoc}
                        setSelectedDoc={handleSelectDoc}
                        isMobile={isMobile}
                        singledata={singledata}
                        singleLoading={singleLoading}
                    />
                </TabPane>

                <TabPane tab="Raise a Ticket" key="raised-ticket">
                    <TicketListTable
                        loading={loading}
                        data={ticketListData}
                        selectedOption={selectedOption}
                        fetchAllTicketListData={fetchAllTicketListData}
                        pagination={pagination}
                        setPagination={setPagination}
                        filters={filters}
                    />
                    <HelpCenterTicketModal
                        open={isModalVisible}
                        onClose={closeModal}
                        selectedOption={selectedOption}
                        fetchMyTicketListData={fetchMyTicketListData}
                        fetchAllTicketListData={fetchAllTicketListData}
                        filters={filters}
                    />
                </TabPane>
            </Tabs>

        </div>
    );
};

export default Helpcenter;
